import { render } from "./MasterDataTablePermissionList.vue?vue&type=template&id=ae1061de&scoped=true&ts=true"
import script from "./MasterDataTablePermissionList.vue?vue&type=script&lang=ts"
export * from "./MasterDataTablePermissionList.vue?vue&type=script&lang=ts"

import "./MasterDataTablePermissionList.vue?vue&type=style&index=0&id=ae1061de&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae1061de"]])

export default __exports__